import { Flow_0_0_2, getFullItemOne, getCurrentUser } from '@flexus/core';
import { map, skipWhile, take, pluck } from 'rxjs/operators';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import gql from 'graphql-tag';

export const SIL_REOPEN_CLAIM: Flow_0_0_2 = {
	id: 'ReopenClaim',
	itemType: 'flow',
	name: 'Reopen Claim',
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				map((itemOne: any) => {
					if (itemOne) {
						return `Re-open Closed Claim: ${itemOne?.loan_information?.mavenclaimnumber} - ${itemOne?.applicant?.surname}`;
					} else {
						return 'Re-open Closed Claim';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	startNode: 'ReopenClaim',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	actionPanel: instance => {
		return () => {
			return [{}];
		};
	},
	includeForOnlyStates: [7, 9],
	nodes: {
		ReopenClaim: {
			component: 'FLXReopenClaimComponent',
			serverCalls: {
				reopenReasons: {
					errorMessage: '',
					directCall: (http, store, sq) => {
						return sq
							.queryObject(
								gql`
									{
										allInfo {
											reopen_reasons {
												id
												description
											}
										}
									}
								`,
								store
							)
							.pipe(
								skipWhile(x => !x),
								pluck('reopen_reasons'),
								take(1)
							);
					}
				}
			},
			inputs: {},
			initFormFields: bf => {
				bf.addControl(
					'reopen_data',
					new UntypedFormGroup({
						reopen_reason: new UntypedFormControl(null, [Validators.required])
					})
				);
			},
			navs: [
				{
					text: 'Re-open Claim',
					color: 'secondary',
					nextNode: 'SubmissionSuccess',
					linkType: 'submit',
					serverFirst: true,
					visible: (bf, store, networkService) => {
						return store.select(getCurrentUser).pipe(
							skipWhile(f => !f),
							pluck('user', 'is_team_leader'),
							take(1),
							map(res => {
								return res as any;
							})
						);
					},
					serverCalls: {
						response: {
							errorMessage: 'Claim was not reopened, something went wrong',
							serviceVariable: 'silService',
							functionName: 'reopenClaim'
						}
					}
				}
			]
		},
		SubmissionSuccess: {
			component: 'FLXSuccessTickComponent',
			navs: []
		}
	},
	bigFormToStoreMapper: {},
	serverCalls: {}
};
